import { ArrowUpRight, Clock, MapPin, Phone } from "lucide-react";
import { IMAGES } from "@/data/mockData";
import { SITE_CONFIG } from "@/data/siteConfig";

export default function Visit() {
  return (
    <div data-testid="visit-page" className="bg-cream">
      <section className="bg-bone border-b border-rule py-16 md:py-24">
        <div className="container-wide grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <p className="text-sm font-semibold text-forest mb-4">Las Vegas, Nevada</p>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1]">
              Visit the shop.
            </h1>
          </div>
          <p className="lg:col-span-5 text-ink leading-relaxed max-w-lg">
            Cactus Rose is proudly located at Booth {SITE_CONFIG.location.booth}
            {" "}inside the Fantastic Indoor Swap Meet.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="container-wide grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <h2 className="font-sans text-2xl md:text-3xl font-semibold">Plan your visit</h2>

            <dl className="mt-8 border-t border-rule">
              <div className="grid grid-cols-[24px_1fr] gap-3 py-5 border-b border-rule">
                <MapPin className="w-4 h-4 mt-0.5 text-forest" strokeWidth={1.7} />
                <div>
                  <dt className="text-xs font-semibold mb-1">Address</dt>
                  <dd className="text-sm leading-relaxed text-ink">
                    {SITE_CONFIG.location.addressLine1}
                    <br />
                    {SITE_CONFIG.location.addressLine2}
                    <br />
                    {SITE_CONFIG.location.venue}
                  </dd>
                </div>
              </div>
              <div className="grid grid-cols-[24px_1fr] gap-3 py-5 border-b border-rule">
                <Phone className="w-4 h-4 mt-0.5 text-forest" strokeWidth={1.7} />
                <div>
                  <dt className="text-xs font-semibold mb-1">Phone</dt>
                  <dd className="text-sm text-ink">
                    <a href={SITE_CONFIG.phone.href} className="hover:text-clay">
                      {SITE_CONFIG.phone.display}
                    </a>
                  </dd>
                </div>
              </div>
            </dl>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href={SITE_CONFIG.links.directions}
                target="_blank"
                rel="noreferrer"
                data-testid="visit-directions-cta"
                className="btn-primary"
              >
                Get Directions
                <ArrowUpRight className="w-4 h-4" strokeWidth={1.7} />
              </a>
              <a href={SITE_CONFIG.phone.href} className="btn-secondary">
                Call the Shop
              </a>
            </div>

            <p className="mt-8 p-5 bg-cactus-wash border border-forest/20 text-sm leading-relaxed text-ink">
              {SITE_CONFIG.inventory.notice}
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="flex items-center gap-2 mb-4">
              <Clock className="w-4 h-4 text-forest" strokeWidth={1.7} />
              <h2 className="font-sans text-2xl md:text-3xl font-semibold">Shop hours</h2>
            </div>
            <dl className="border-t border-rule" data-testid="visit-hours">
              {SITE_CONFIG.hours.rows.map(([days, hours]) => (
                <div key={days} className="flex items-baseline justify-between gap-6 py-5 border-b border-rule">
                  <dt className="font-medium">{days}</dt>
                  <dd className="text-sm text-ink text-right">{hours}</dd>
                </div>
              ))}
            </dl>

            <div className="mt-10 aspect-[4/3] overflow-hidden bg-oat">
              <img
                src={IMAGES.store}
                alt="Yarn and needle-arts supplies at Cactus Rose"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
